import React, { useState, useEffect } from 'react';
import {
  Container,
  Paper,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  Avatar,
  Badge,
  Divider,
  CircularProgress
} from '@mui/material';
import { Person } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import AppHeader from '../components/AppHeader';

const API_URL = process.env.REACT_APP_API_URL || '';

export default function MessagesPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [unreadCounts, setUnreadCounts] = useState({});

  useEffect(() => {
    loadUsers();
    loadUnreadCounts();
  }, []);

  const loadUsers = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/users/list`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      // Filter out current user
      const otherUsers = response.data.users.filter(u => u.username !== user?.username);
      setUsers(otherUsers);
    } catch (error) {
      console.error('Error loading users:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadUnreadCounts = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/messages`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      // Count unread messages per sender
      const counts = {};
      response.data.messages.forEach(msg => {
        if (msg.receiver_id === user?.username && !msg.is_read) {
          counts[msg.sender_id] = (counts[msg.sender_id] || 0) + 1;
        }
      });
      setUnreadCounts(counts);
    } catch (error) {
      console.error('Error loading unread counts:', error);
    }
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppHeader title="Nachrichten" showBack={true} backTo="/dashboard" />

      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Paper sx={{ p: 2 }}>
          <Typography variant="h6" gutterBottom>
            Benutzer
          </Typography>
          
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
              <CircularProgress />
            </Box>
          ) : (
            <List>
              {users.map((u, index) => (
                <React.Fragment key={u.username}>
                  <ListItemButton onClick={() => navigate(`/messages/chat/${u.username}`)}>
                    <Badge 
                      badgeContent={unreadCounts[u.username] || 0} 
                      color="error"
                      sx={{ mr: 2 }}
                    >
                      <Avatar sx={{ bgcolor: u.role === 'admin' ? '#d32f2f' : '#2196f3' }}>
                        <Person />
                      </Avatar>
                    </Badge>
                    <ListItemText
                      primary={u.full_name}
                      secondary={u.role === 'admin' ? 'Administrator' : 'Monteur'}
                      primaryTypographyProps={{
                        fontWeight: unreadCounts[u.username] ? 'bold' : 'normal'
                      }}
                    />
                  </ListItemButton>
                  {index < users.length - 1 && <Divider />}
                </React.Fragment>
              ))}
            </List>
          )}
        </Paper>
      </Container>
    </Box>
  );
}
